import {StringUtils, Utils} from 'neo-common';
import {GameResponse} from './GameResponse';

/**
 * @class InitResponse - response for "Init" request.
 */
export class InitResponse extends GameResponse {
    /**
     * @property initData - game initialization data. Sent only for Initialize request.
     */
    initData: {
        /**
         * @property currency - ISO 4217 code for currency
         */
        currency: string;

        /**
         * @property denomination - denomination of 1 credit in cents
         */
        denomination: number;

        /**
         * @property customData - custom data for init action
         */
        customData?: any;

        /**
         * @property - Message ID that was used to start last game round.
         */
        startMessageId: number;
    };

    protected internalValidate(errors: Array<string>): void {
        super.internalValidate(errors);

        if (Utils.isNullOrUndefined(this.initData)) {
            errors.push('Property "initData" is missing or has null/undefined value!');
        } else {
            if (StringUtils.isNullOrEmpty(this.initData.currency)) {
                errors.push('Property "initData.currency" is missing or has null/undefined value!');
            }

            if (Utils.isNullOrUndefined(this.initData.denomination)) {
                errors.push('Property "initData.denomination" is missing or has null/undefined value!');
            } else if (typeof this.initData.denomination !== 'number') {
                errors.push('Property "initData.denomination" has wrong type, required type is "number"!');
            }
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Responses/InitResponse.ts
 **/